var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80926 6L9.91082 1.11094C9.97957 1.02969 9.92175 0.90625 9.81551 0.90625H8.56863C8.49519 0.90625 8.42488 0.939062 8.37644 0.995312L4.99363 5.02813L1.61082 0.995312C1.56394 0.939062 1.49363 0.90625 1.41863 0.90625H0.171756C0.0655061 0.90625 0.00769352 1.02969 0.0764435 1.11094L4.17801 6L0.0764435 10.8891C0.0610429 10.9072 0.0511628 10.9293 0.0479759 10.9529C0.0447889 10.9764 0.048429 11.0004 0.0584644 11.022C0.0684997 11.0435 0.0845088 11.0617 0.10459 11.0745C0.124672 11.0872 0.147983 11.0939 0.171756 11.0938H1.41863C1.49207 11.0938 1.56238 11.0609 1.61082 11.0047L4.99363 6.97188L8.37644 11.0047C8.42332 11.0609 8.49363 11.0938 8.56863 11.0938H9.81551C9.92175 11.0938 9.97957 10.9703 9.91082 10.8891L5.80926 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close-black.2238826304ddc002150c94a4b36da0ef.svg";
export { ForwardRef as ReactComponent };